// extracted by mini-css-extract-plugin
module.exports = {"loaderWrap":"Loader_loaderWrap__3ipRi","bounce":"Loader_bounce__2kPRN","disappear":"Loader_disappear__16uNv","appear":"Loader_appear__17ERc","pokeball":"Loader_pokeball__5BV-z"};